'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createIconComponent = require('./utils/createIconComponent');

var _createIconComponent2 = _interopRequireDefault(_createIconComponent);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconSmallFormatCategory = (0, _createIconComponent2.default)({ fillContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { fill: 'none', d: 'M.025 0h24v24h-24z', 'data-name': 'Invisible_Shape' }),
    _react2.default.createElement('path', { d: 'M23.5 4.5H.5A.5.5 0 0 0 0 5v14a.5.5 0 0 0 .5.5h23a.5.5 0 0 0 .5-.5V5a.5.5 0 0 0-.5-.5zm-.5 14H1v-13h22zM6.953 7.167l-1.747 3.057-.92-1.533L2 12.5h8zM4.477 11.5h-.711l.52-.866.351.585zm1.151 0l1.325-2.317L8.277 11.5zM13 17a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 0 1h-8a.5.5 0 0 1-.5-.5zm4-2a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5z' })
  ), lightContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { fill: 'none', d: 'M.025 0h24v24h-24z', 'data-name': 'Invisible_Shape' }),
    _react2.default.createElement('path', { d: 'M23.5 4.5H.5A.5.5 0 0 0 0 5v14a.5.5 0 0 0 .5.5h23a.5.5 0 0 0 .5-.5V5a.5.5 0 0 0-.5-.5zm-.5 14H1v-13h22zM6.953 7.167l-1.747 3.057-.92-1.533L2 12.5h8zM4.477 11.5h-.711l.52-.866.351.585zm1.151 0l1.325-2.317L8.277 11.5zM13 17a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 0 1h-8a.5.5 0 0 1-.5-.5zm4-2a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5z' })
  ), regularContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { fill: 'none', d: 'M.025 0h24v24h-24z', 'data-name': 'Invisible_Shape' }),
    _react2.default.createElement('path', { d: 'M23.5 4.5H.5A.5.5 0 0 0 0 5v14a.5.5 0 0 0 .5.5h23a.5.5 0 0 0 .5-.5V5a.5.5 0 0 0-.5-.5zm-.5 14H1v-13h22zM6.953 7.167l-1.747 3.057-.92-1.533L2 12.5h8zM4.477 11.5h-.711l.52-.866.351.585zm1.151 0l1.325-2.317L8.277 11.5zM13 17a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 0 1h-8a.5.5 0 0 1-.5-.5zm4-2a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5z' })
  ), height: undefined, width: undefined, viewBox: "0 0 24 24" });
IconSmallFormatCategory.displayName = 'IconSmallFormatCategory';
exports.default = IconSmallFormatCategory;